/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBarberShiftPauseMutationRequest, PostApiBarberShiftPauseMutationResponse, PostApiBarberShiftPause400, PostApiBarberShiftPause401, PostApiBarberShiftPause403, PostApiBarberShiftPause404, PostApiBarberShiftPause500 } from "../entities/PostApiBarberShiftPause";

function getPostApiBarberShiftPauseUrl() {
  const res = { method: 'POST', url: `/api/barber/shift/pause` as const }
  return res
}

/**
 * @description Поставить текущую смену на паузу
 * @summary Поставить на паузу
 * {@link /api/barber/shift/pause}
 */
export async function postApiBarberShiftPause(data: PostApiBarberShiftPauseMutationRequest, config: Partial<RequestConfig<PostApiBarberShiftPauseMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<PostApiBarberShiftPauseMutationResponse, ResponseErrorConfig<PostApiBarberShiftPause400 | PostApiBarberShiftPause401 | PostApiBarberShiftPause403 | PostApiBarberShiftPause404 | PostApiBarberShiftPause500>, PostApiBarberShiftPauseMutationRequest>({ method : "POST", url : getPostApiBarberShiftPauseUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}